export const SignalData = {
    tcFast: [
        {label: 'Any', value: 'Any'},
        {label: 'TC Fast Trade Buy Signal', value: 'TC Fast Trade Buy Signal'},
        {label: 'TC Fast Trade Sell Signal', value: 'TC Fast Trade Sell Signal'}
    ],
    tcPositional: [
        {label: 'Any', value: 'Any'},
        {label: 'TC Positional Trade Buy Signal', value: 'TC Positional Trade Buy Signal'},
        {label: 'TC Positional Trade Sell Signal', value: 'TC Positional Trade Sell Signal'}
    ],
    goldenSpike: [
        {label: 'Any', value: 'Any'},
        {label: 'Golden Spike Trade Buy Signal', value: 'Golden Spike Trade Buy Signal'},
        {label: 'Golden Spike Trade Sell Signal', value: 'Golden Spike Trade Sell Signal'}
    ],
    turtalTrading: [
        {label: 'Any', value: 'Any'},
        {label: 'Turtle Trade Buy Signal', value: 'Turtle Trade Buy Signal'},
        {label: 'Turtle Trade Sell Signal', value: 'Turtle Trade Sell Signal'}
    ],
    trade4All: [
        {label: 'Any', value: 'Any'},
        {label: 'trade4All Trade Buy Signal', value: 'trade4All Trade Buy Signal'},
        {label: 'trade4All Trade Sell Signal', value: 'trade4All Trade Sell Signal'}
    ]
};

